import { init, reactRouterV5BrowserTracingIntegration } from '@sentry/react'
import { matchPath } from 'react-router-dom'

import 'styles/style'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import en from 'dayjs/locale/en'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import timezone from 'dayjs/plugin/timezone'
import isoWeek from 'dayjs/plugin/isoWeek'
import constants from 'config/constants'
import { sentryRoutes } from 'config/sentryRoutes'
import { history } from 'libs/history'

const customTimezonePlugin = (_, dayjsClass) => {
  // Store reference to original tz method before overriding
  const originalTz = dayjsClass.prototype.tz

  dayjsClass.prototype.tz = function (timezone) {
    if (timezone === 'Etc/GMT') {
      return this.utc()
    }
    // Call the original tz method with proper context
    return originalTz.apply(this, arguments)
  }
}

dayjs.locale({
  ...en,
  weekStart: 1,
})

dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)
dayjs.extend(quarterOfYear)
dayjs.extend(advancedFormat)
dayjs.extend(isoWeek)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customTimezonePlugin)

init({
  dsn: constants.sentryDSN,
  integrations: [
    reactRouterV5BrowserTracingIntegration({ history, routes: sentryRoutes, matchPath }),
  ],
  environment: process.env.REACT_APP_BUILD_ENVIRONMENT || process.env.NODE_ENV,
  tracesSampleRate: constants.sentryTracesSampleRate,
})



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/configure.js